import React, {Component} from 'react';
import { avatarUrl  } from "../api"

class AvatarDisplay extends Component {
    constructor(props) {
        super(props);
        const avatar = this.props.userId ? avatarUrl(this.props.userId) : `${process.env.PUBLIC_URL}/assets/images/avatars/m_blank_avatar.jpg`

        this.state = {
            src: this.props.src ? this.props.src : avatar,
            sequence: 0
        }
        this.defaultSrc = this.defaultSrc.bind(this)

    }

    componentDidUpdate(prevProps) {
        if(prevProps.src !== this.props.src) {
            this.setState({src: this.props.src ? this.props.src : this.avatar})
        }
        if(prevProps.sequence !== this.props.sequence) {
            this.setState({
                sequence: this.props.sequence, 
                src: this.props.userId ? avatarUrl(this.props.userId)+`?seq=${this.props.sequence}` : `${process.env.PUBLIC_URL}/assets/images/avatars/m_blank_avatar.jpg`})
        }
    }

    defaultSrc(ev) {
        const avatar = `${process.env.PUBLIC_URL}/assets/images/avatars/m_blank_avatar.jpg`

        ev.target.src = avatar
    }

    renderSwitch(size, pad) {
        return (
        <img src={this.state.src} alt="avatar" onError={this.defaultSrc}
            style={{
                borderRadius: "100%",
                border: "1px solid #dddddd",
                padding: `${pad}px`,
                height: `${size}px`,
                width: `${size}px`
            }}
        />   
        ) 
    }

    render () {
        const {prefix, suffix, suffix2} = this.props;
        const size = this.props.size ? this.props.size : 180;
        const pad = size > 100 ? 5 : 2
        return (
            <>
            {size > 100 
            ?   <div className="media">
                    <div className="text-center">
                        {prefix && <>
                        <h5>{prefix}</h5>
                        </>}
                            
                        {this.renderSwitch(size, pad)}
                        
                        {suffix && <>
                        <br/>
                        <h6>{suffix}</h6>
                        {suffix2 && <p>{suffix2}</p>}
                        </>}
                    </div>
                </div> 
            : <>{this.renderSwitch(size, pad)}</>
            }
            </>
        )
    }
}

export default AvatarDisplay;